export default __webpack_public_path__ + "static/media/menu.0e781e66.svg";